/** @flow */

export const dataURLtoFile = (str: string) => {
  // extract content type and base64 payload from original string
  let posBase64 = str.indexOf(";base64,");
  let posName = str.indexOf(";name=");
  let type = str.substring(5, posName);
  let name = decodeURIComponent(str.substring(posName + 6, posBase64));
  let b64 = str.substring(posBase64 + 8);

  // TODO: Temporary disabled code
  // if (posBase64 === -1 || !b64) {
  //   throw new Error(`Invalid or empty data URL provided for file "${name || "unknown"}"`);
  // }

  // decode base64
  let content = atob(b64);

  // TODO: Temporary disabled code
  // if (content.length < 1) {
  //   throw new Error(`Empty file content, try to re-uplaod the file `);
  // }
  // create an ArrayBuffer and a view (as unsigned 8-bit)
  let buffer = new ArrayBuffer(content.length);
  let view = new Uint8Array(buffer);

  // fill the view, using the decoded base64
  for (let n = 0; n < content.length; n++) {
    view[n] = content.charCodeAt(n);
  }

  // convert ArrayBuffer to Blob
  let blob = new Blob([buffer], { type });
  // TODO: Temporary disabled code
  // if (blob.size < 1) {
  //   throw new Error(`Empty file, try to re-uplaod the file`);
  // }
  return { blob, name };
};

export const getAssetPDF = (filename: string) => {
  window.open(`/assets/pdf/${filename}`, "_blank");
};
